import { Popover } from "react-aria-components";
import React, { ComponentProps } from "react";
import clsx from "clsx";

import styles from "./dropdown-popover.module.css";

interface DropdownPopover {
  children: React.ReactNode;
  className?: string;
  placement?: ComponentProps<typeof Popover>["placement"];
  /**
   * Anchors the popover to an element that is not its `DialogTrigger`, for a
   * consumer that owns the open state itself (`Select`, which anchors to its
   * field) and passes `isOpen`/`onOpenChange` with it.
   */
  triggerRef?: ComponentProps<typeof Popover>["triggerRef"];
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
}

export default function DropdownPopover({
  children,
  className,
  placement = "bottom left",
  triggerRef,
  isOpen,
  onOpenChange,
}: DropdownPopover) {
  return (
    <Popover
      className={clsx(styles.popOver, className)}
      placement={placement}
      triggerRef={triggerRef}
      // Omitted rather than passed as `undefined`: react-aria-components reads
      // a present `isOpen` as "the consumer controls this", so handing it one
      // would strand every DialogTrigger-nested consumer permanently closed.
      {...(isOpen === undefined ? {} : { isOpen })}
      onOpenChange={onOpenChange}
    >
      {children}
    </Popover>
  );
}
